import { render, staticRenderFns } from "./RepairSchoolConfig.vue?vue&type=template&id=7396dc97&scoped=true"
import script from "./RepairSchoolConfig.vue?vue&type=script&lang=js"
export * from "./RepairSchoolConfig.vue?vue&type=script&lang=js"
import style0 from "./RepairSchoolConfig.vue?vue&type=style&index=0&id=7396dc97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7396dc97",
  null
  
)

export default component.exports